var render = function render(){var _vm=this,_c=_vm._self._c;return _c('section',[_c('v-table',{attrs:{"url":"/api/v1/customerProfile","filter":[
      {
        name: 'coupon',
        value: _vm.id
      }
    ],"attributes":[
      {
        attribute: 'name',
        name: 'Name'
      },
      {
        attribute: 'coupons[0].pivot.created_at',
        name: 'Eingelöst am',
        type: 'DateTimeCell'
      }
    ]}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }